import { useNavigate } from "react-router-dom";
import { BseStatusDto, EventKindDto, EventListItemDto } from "../../autogen/bff-api";
import { urls } from "../../urls";

// Centralised routing for an event row click — keeps BSE and V2 destinations
// consistent across the buyer table, home dashboard, and any future surface
// that consumes EventListItemDto.
export const useEventNavigation = () => {
  const navigate = useNavigate();
  return (event: EventListItemDto) => {
    if (event.kind === EventKindDto.V2) {
      navigate(urls.v2.sourcingEvents.view.go(event.id));
      return;
    }
    if (event.bseStatus === BseStatusDto.Draft) {
      navigate(urls.events.edit.go(event.id).intro);
    } else {
      navigate(urls.events.view.go(event.id));
    }
  };
};
